import { render } from "./ParameterHelp.vue?vue&type=template&id=0936c774&ts=true"
import script from "./ParameterHelp.vue?vue&type=script&lang=ts"
export * from "./ParameterHelp.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__